import { render } from "./menubarES.vue?vue&type=template&id=60563c5e&scoped=true"
import script from "./menubarES.vue?vue&type=script&lang=js"
export * from "./menubarES.vue?vue&type=script&lang=js"

import "./menubarES.vue?vue&type=style&index=0&id=60563c5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60563c5e"]])

export default __exports__